import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { BellRing, Clock } from "lucide-react";
import { consultApi, consultError } from "../lib/consult";
import { useConsultEnabled } from "../lib/useConsultEnabled";
import { ButtonRing } from "../components/LoadingRing";

export default function ConsultationComingSoon() {
    const { comingSoon } = useConsultEnabled();
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [done, setDone] = useState(false);
    const [busy, setBusy] = useState(false);

    const join = async () => {
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return toast.error("Please enter a valid email");
        setBusy(true);
        try {
            await consultApi.post("/waitlist", { email, name });
            setDone(true);
            toast.success("You are on the list");
        } catch (e) { toast.error(consultError(e)); } finally { setBusy(false); }
    };

    return (
        <div className="pt-32 md:pt-40 pb-28" data-testid="consultation-coming-soon-page">
            <div className="mx-auto max-w-3xl px-6 md:px-10">
                <div className="inline-flex items-center gap-2 mono text-[10px] tracking-[0.22em] text-gold border border-gold/30 px-3 py-1.5">
                    <Clock className="w-3.5 h-3.5" /> COMING SOON
                </div>
                <h1 className="mt-7 font-display text-4xl sm:text-5xl lg:text-6xl uppercase tracking-tight leading-[0.95]"
                    data-testid="coming-soon-heading">
                    {comingSoon.heading || "Consultations opening soon"}
                </h1>
                <p className="mt-6 text-zinc-400 max-w-xl leading-relaxed" data-testid="coming-soon-message">
                    {comingSoon.message}
                </p>

                {comingSoon.notify_enabled !== false && (
                    done ? (
                        <div className="mt-10 border border-lime/40 bg-lime/[0.07] p-6" data-testid="coming-soon-done">
                            <div className="font-display text-2xl uppercase tracking-tight">You're on the list</div>
                            <p className="mt-2 text-sm text-zinc-300">We will write to you the day consultations open.</p>
                        </div>
                    ) : (
                        <div className="mt-10 border border-white/10 bg-bg1 p-6" data-testid="coming-soon-notify">
                            <div className="mono text-[10px] tracking-[0.22em] text-zinc-500 flex items-center gap-2">
                                <BellRing className="w-3.5 h-3.5 text-gold" /> NOTIFY ME
                            </div>
                            <div className="mt-4 flex flex-col sm:flex-row gap-3">
                                <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Your name (optional)"
                                    data-testid="coming-soon-name"
                                    className="sm:w-44 bg-bg0 border border-white/12 text-white px-3 py-3 text-sm outline-none focus:border-gold placeholder:text-zinc-600" />
                                <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
                                    data-testid="coming-soon-email"
                                    className="flex-1 bg-bg0 border border-white/12 text-white px-3 py-3 text-sm outline-none focus:border-gold placeholder:text-zinc-600" />
                                <button onClick={join} disabled={busy} data-testid="coming-soon-submit"
                                    className="btn-pill btn-primary justify-center">
                                    {busy ? <ButtonRing /> : "Keep me posted"}
                                </button>
                            </div>
                        </div>
                    )
                )}

                <div className="mt-12 flex flex-wrap gap-3">
                    <Link to="/shop" className="btn-pill btn-secondary" data-testid="coming-soon-shop">Explore our range</Link>
                    <Link to="/science" className="btn-pill btn-secondary" data-testid="coming-soon-science">The science</Link>
                </div>
            </div>
        </div>
    );
}
